module.exports = __webpack_public_path__ + "static/media/colombia-flag.edddbdb5.png";